"use client";
import { ChevronUpIcon } from "@heroicons/react/24/outline";
import { useEffect, useState } from "react";

export default function ScrollBtn() {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollButton(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      {showScrollButton && (
        <button
          className="fixed bottom-[75px] right-6 bg-light-blue z-30 text-dark-blue rounded-full p-2 shadow-[0_8px_30px_rgb(0,0,0,0.12)] transition-all hover:scale-110"
          onClick={scrollToTop}
        >
          <ChevronUpIcon className="h-6 w-6" />
        </button>
      )}
    </div>
  );
}
